var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_55555",
    "data-name": "\\uADF8\\uB8F9 55555",
    transform: "translate(-380 -223)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_86",
    "data-name": "\\uC0AC\\uAC01\\uD615 86",
    width: 32,
    height: 32,
    transform: "translate(380 223)",
    fill: "#ff2727",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_191",
    "data-name": "\\uC0AC\\uAC01\\uD615 191",
    width: 28,
    height: 28,
    rx: 14,
    transform: "translate(382 225)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_16",
    "data-name": "\\uD328\\uC2A4 16",
    d: "M6.258,1.621A4.906,4.906,0,0,0,10.109-.122L8.619-1.9A3.037,3.037,0,0,1,6.369-.819c-1.664,0-2.741-1.363-2.741-3.708,0-2.3,1.252-3.66,2.773-3.66a2.991,2.991,0,0,1,2.06.919L9.935-9.075a5.022,5.022,0,0,0-3.581-1.537c-2.995,0-5.625,2.25-5.625,6.18C.728-.439,3.263,1.621,6.258,1.621Z",
    transform: "translate(390.128 243.495)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.440acd9b0d17a10677b72b0a12aba6c4.svg";
export { ForwardRef as ReactComponent };